import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlayCircle, faCircle, faMapMarkerAlt, faVideo } from '@fortawesome/free-solid-svg-icons'

import { useAnalytics } from "libs/analytics";

// import './Loader.scss'

export default function ShowImage(props) {
    const { show, viewerShow, ...otherProps } = props

    const { trackEvent } = useAnalytics();

    function onClickHandler() {
        const action = props.analyticsTrackAction || 'Clicked Play Overlay'
        const category = props.analyticsTrackCategory || 'Show'

        trackEvent({
            action: action,
            category: category
        });
    }

    function render() {
        const isPresencial = show.venue !== 'Online';
        const badgeText = isPresencial ? 'EVENTO PRESENCIAL' : 'VIRTUAL';
        const hasImage = !!show.main_image;
        const renderPlayButton = (show?.settings?.nologin && !['CLOSED','CANCELLED'].includes(show.status) ) 
            || ((viewerShow || !show.paid ) && ['STARTED','LIVE','REPLAY'].includes(show.status) )

        const playerUrl = viewerShow
            ? `/shows/${show._id}/player/?code=${viewerShow.payment_info.request_code}`
            : `/shows/${show._id}/player/`

        return <div className="show-image">                    
            {hasImage ? (
                <img src={show.main_image} alt={show.fullname} className="show-image-img" />
            ) : (
                <div className="show-image-placeholder">
                    <FontAwesomeIcon icon={faPlayCircle} size="3x" />
                </div>
            )}
            <div className={`show-image-badge show-badge ${isPresencial ? 'presencial' : 'online'}`}>
                <FontAwesomeIcon 
                    icon={isPresencial ? faMapMarkerAlt : faVideo} 
                    className="badge-icon"
                />
                {badgeText}
            </div>
            {renderPlayButton && <>
            <div className="play-overlay">
                <a href={playerUrl} target="_blank" className="d-flex justify-content-center align-items-center" onClick={onClickHandler}><FontAwesomeIcon icon={faPlayCircle} /></a>
                {show.status == "LIVE" &&
                <div className="live-overlay"><div><FontAwesomeIcon icon={faCircle} style={{color:"red"}} />&nbsp;&nbsp;EN VIVO</div></div>
                }
            </div>                            
            </>}
            
        </div>
    }

    return render()
}